import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchProspects } from '../../prospects/api'
import { fetchPrograms } from '../../programs/api'
import { AGENT_ONBOARDING_STEPS } from '../lib/steps'
import { useAuthSession } from '../../auth/session'

export function useAgentOnboardingSteps() {
  const { user } = useAuthSession()
  const prospectsQuery = useQuery({
    queryKey: ['dashboard', 'agent-prospects'],
    queryFn: fetchProspects,
  })

  const programsQuery = useQuery({
    queryKey: ['dashboard', 'agent-programs'],
    queryFn: fetchPrograms,
  })

  const isLoading = prospectsQuery.isLoading || programsQuery.isLoading

  const state = useMemo(() => {
    const prospects = (prospectsQuery.data?.data ?? []).filter((p) => !p.deleted_at)
    return {
      avatar_set: !!(user?.avatar_url?.trim()),
      programs_count: programsQuery.data?.data?.length ?? 0,
      prospects_count: prospects.length,
      converted_prospects_count: prospects.filter((p) => p.conversion_status === 'converted').length,
    }
  }, [prospectsQuery.data, programsQuery.data, user?.avatar_url])

  const steps = AGENT_ONBOARDING_STEPS.map((s) => ({
    ...s,
    completed: s.isComplete(state),
  }))

  const completedCount = steps.filter((s) => s.completed).length

  return {
    steps,
    completedCount,
    totalCount: steps.length,
    allComplete: completedCount === steps.length,
    isLoading,
  }
}
